import { render, staticRenderFns } from "./Crisantemi.vue?vue&type=template&id=3fd9f7e8&"
import script from "./Crisantemi.vue?vue&type=script&lang=js&"
export * from "./Crisantemi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports